import {observer} from 'mobx-react';
import {PanelTooltip} from 'shared/components';
import {t} from 'shared/core';
import _ from 'lodash';

const LieuTimeTooltip = observer(({lieuTimeAmount}) => {
  if (parseFloat(lieuTimeAmount) === 0) return null;

  return (
    <PanelTooltip>
      <span className='mr2'>{t('time_tracking.timesheet.TIME_IN_LIEU')}</span><span className='medium'>{lieuTimeAmount}</span>
    </PanelTooltip>
  );
});

const StraightLieuTimeTooltip = observer(({totals}) => {
  if (!parseFloat(totals.straightLieuTime)) return null;

  const lieu = parseFloat(totals.straightLieuTime);
  const paid = _.round(parseFloat(totals.regular) - lieu, 2);

  return (
    <PanelTooltip>
      <div><span className='mr2'>{t('time_tracking.timesheet.Paid Hours')}</span><span className='medium'>{paid}</span></div>
      <div><span className='mr2'>{t('time_tracking.timesheet.Lieu Time')}</span><span className='medium'>{lieu}</span></div>
    </PanelTooltip>
  );
});

const PTOBreakdownTooltip = observer(({uiState}) => {
  const {timesheet} = uiState;

  if (_.isEmpty(timesheet.totals.pto)) return null;

  return (
    <PanelTooltip>
      {Object.entries(timesheet.totals.pto).map(
        ([key, value]) => <div key={key}><span className='mr2'>{uiState.typeNameById(key)}</span><span className='medium'>{value}</span></div>
      )}
    </PanelTooltip>
  );
});

const HolidayBreakdownTooltip = observer(({uiState}) => {
  const {timesheet} = uiState;

  if (_.isEmpty(timesheet.totals.holidays)) return null;

  return (
    <PanelTooltip>
      {Object.entries(timesheet.totals.holidays).map(
        ([key, value]) => <div key={key}><span className='mr2'>{timesheet.holidayNameById(key)}</span><span className='medium'>{value}</span></div>
      )}
    </PanelTooltip>
  );
});

const Metric = ({label, value, children}) => {
  return (
    <div className='mr2 flex align-items-middle'>
      <div className='jumbo mr1'>{t(label)}</div>
      <div className='black flex'><span>{value}</span><span>{children}</span></div>
    </div>
  );
};

const MetricSpacer = () => {
  return (
    <div className='mr2 jumbo'>{'|'}</div>
  );
};

const Totals = observer(({uiState}) => {
  const {timesheet} = uiState;

  return (
    <div className='border-bottom border-top flex py3 mb2 align-items-middle flex-wrap' style={{marginLeft: '-1.5rem', marginRight: '-1.5rem', paddingRight: '1.5rem', paddingLeft: '1.5rem'}}>
      <Metric label='time_tracking.timesheet.Regular' value={timesheet.totals.regular}>
        <StraightLieuTimeTooltip totals={timesheet.totals}/>
      </Metric>
      <MetricSpacer/>
      <Metric label='time_tracking.timesheet.Overtime' value={timesheet.totals.overtime}>
        <LieuTimeTooltip lieuTimeAmount={timesheet.totals.overtimeLieuTime}/>
      </Metric>
      <MetricSpacer/>
      <Metric label='time_tracking.timesheet.Double Overtime' value={timesheet.totals.doubleOvertime}>
        <LieuTimeTooltip lieuTimeAmount={timesheet.totals.doubleOvertimeLieuTime}/>
      </Metric>
      <MetricSpacer/>
      <Metric label='time_tracking.timesheet.Holiday Worked' value={timesheet.totals.holidaysTotal}>
        <HolidayBreakdownTooltip uiState={uiState}/>
      </Metric>
      <MetricSpacer/>
      <Metric label='time_tracking.timesheet.Paid Time Off' value={timesheet.totals.ptoTotal}>
        <PTOBreakdownTooltip uiState={uiState}/>
      </Metric>
      <MetricSpacer/>
      <Metric label='time_tracking.timesheet.Total' value={timesheet.totals.total}/>
    </div>
  );
});

export default Totals;
